import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "basket-list"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CartListItem = _resolveComponent("CartListItem");
  const _directive_auto_animate = _resolveDirective("auto-animate");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cart, item => {
    return _openBlock(), _createBlock(_component_CartListItem, {
      key: item.id,
      title: item.title,
      weight: item.weight,
      filename: item.imgUrl,
      price: item.price,
      count: item.count,
      category: item.category,
      id: item.id,
      onOnClickRemove: () => $setup.removeFromCart(item),
      onOnClickPlus: () => $setup.countPlus(item),
      onOnClickMinus: () => $setup.countMinus(item)
    }, null, 8, ["title", "weight", "filename", "price", "count", "category", "id", "onOnClickRemove", "onOnClickPlus", "onOnClickMinus"]);
  }), 128))])), [[_directive_auto_animate]]);
}